// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"18":"dc8934d3","48":"de486fd3","78":"b5df3931","338":"30c1649b","390":"77448486","426":"3a4ca59a","544":"ad152fa3","576":"065874fb","753":"c48b71c2","775":"5b597a97","799":"0ced418b","823":"60aaf389","827":"0ea93c5e","891":"d139a9d9","990":"86f9a6c1"}[chunkId] + ".js";
};